<template>
  <div>
    <div class="row">
      <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
        <div class="card">
          <div class="card-header">
            <strong>{{web_texts.partials.mag_diff_well}}</strong>
          </div>
          <div class="card-block" style="min-height: 352px">
            <div class="row">
              <div class="col-md-7" style="margin-top: 13px">
                <i class="icon-shuffle font-2xl"></i>
                <span class="px-2">{{web_texts.partials.status}}</span>
              </div>
              <button v-if="mag_dif_well==='ON'" class="btn col-md-5 btn-success btn-lg btn-block" @click="changeStatusMagDif('well','OFF')">ON</button>
              <button v-else-if="mag_dif_well==='OFF'" type="button" class="btn col-md-5 btn-btn-danger btn-lg btn-block" @click="changeStatusMagDif('well','ON')">OFF</button>
              <button v-else="" class="btn col-md-5 btn-default btn-lg btn-block" disabled>S/D</button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
        <div class="card">
          <div class="card-header">
            <strong>{{web_texts.partials.shuntings}}</strong>
          </div>
          <div class="card-block" style="min-height: 352px">
            <vue-good-table :columns="columns" :rows="list_events_well" :paginate="true" :perPage="4"
                            :defaultSortBy="{field: 'date', type: 'desc'}">
              <template slot="table-row" scope="props">
                <td :class="props.row.value">{{ props.row.date }}</td>
                <td :class="props.row.value">{{ props.row.shunter }}</td>
                <td :class="props.row.value">{{ props.row.value }}</td>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
        <div class="card">
          <div class="card-header">
            <strong>{{web_texts.partials.mag_diff_raft}}</strong>
          </div>
          <div class="card-block" style="min-height: 352px">
            <div class="row">
              <div class="col-md-7" style="margin-top: 13px">
                <i class="icon-shuffle font-2xl"></i>
                <span class="px-2">{{web_texts.partials.status}}</span>
              </div>
              <button v-if="mag_dif_raft==='ON'" class="btn col-md-5 btn-success btn-lg btn-block" @click="changeStatusMagDif('raft','OFF')">ON</button>
              <button v-else-if="mag_dif_raft==='OFF'" type="button" class="btn col-md-5 btn-danger btn-lg btn-block" @click="changeStatusMagDif('raft','ON')">OFF</button>
              <button v-else="" class="btn col-md-5 btn-default btn-lg btn-block" disabled>S/D</button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
        <div class="card">
          <div class="card-header">
            <strong>{{web_texts.partials.shuntings}}</strong>
          </div>
          <div class="card-block" style="min-height: 352px">
            <vue-good-table :columns="columns" :rows="list_events_raft" :paginate="true" :perPage="4"
                            :defaultSortBy="{field: 'date', type: 'desc'}">
              <template slot="table-row" scope="props">
                <td :class="props.row.value">{{ props.row.date }}</td>
                <td :class="props.row.value">{{ props.row.shunter }}</td>
                <td :class="props.row.value">{{ props.row.value }}</td>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import trans_cat from '../../../translates/cat/Shuntting';
  import trans_es from '../../../translates/es/Shuntting';
  import middleware from '../../../utilities/middlewares';
  import constants from '../../../constants';

  export default {
    name: 'DiffShunting',
    data() {
      return {
        web_texts: { "generator": "Grup Electrogen", "pump": "Bomba-Bassa", "diffs": "Magnetos-Diferencials", "partials": { "raft_level": "Nivell Bassa", "cabdal": "Cabal Aigua", "pump_status": "Estat Bomba", "shuntings": "Maniobres", "start_mode": "Mode d\'arranc", "physical_selector": "Selector fisic", "shunting": "Maniobra", "historical_shunting": "Històric maniobres", "historical_raft_level": "Històric nivell bassa", "contracted_power": "Pot. Contractada", "general_power": "Pot. General", "generator_power": "Pot. Grup", "shunting_status": "Estat Maniobra", "selector_status": "Estat Selector", "contactor_status": "Estat Contactor", "net_supply": "XARXA", "generator": "GRUP", "generator_status": "Estat Grup", "emergency_stop": "Parada d\'emergència", "deactivated": "DESACTIVAT", "compare_powers": "Comparativa Pot. General - Pot. Grup", "mag_diff_well": "Mag/Dif Pou", "mag_diff_raft": "Mag/Dif Bassa", "status": "Estat" } },
        system: '',
        masters: '',
        mag_dif_well: 'S/D',
        mag_dif_raft: 'S/D',
        list_events_raft: [],
        list_events_well: [],
        columns: [
          {
            label: 'Data',
            field: 'date',
            type: 'date',
            inputFormat: 'DD/MM/YYYY HH:mm:ss',
            width: '180px',
            html: true
          },
          {
            label: 'Dispositiu',
            field: 'shunter',
            html: true
          },
          {
            label: 'Estat',
            field: 'value',
            html: true
          }
        ]
      }
    },
    created() {
      middleware.userIsLoged();
      window.localStorage.setItem('real_time_control', '["shunt","diffs_shunt"]');
      this.web_texts=middleware.selectTranslation(trans_cat,trans_es);
      var out = this;

      this.system = JSON.parse(window.localStorage.getItem('system'));
      this.masters = JSON.parse(window.localStorage.getItem('masters'));

      this.haveMagnets(this.masters[0].id);
      this.getEventsGenerator('well', 'R$EVE_E_MagnetoDif_Pou_ON');
      this.getEventsGenerator('raft', 'R$EVE_E_MagnetoDif_Bassa_ON');

      console.log("Created diffs Shunt");
      var diffs_shunt_interval = setInterval(function () {
        console.log("Interval diffs Shunt");
        var contr_rt = JSON.parse(window.localStorage.getItem('real_time_control'));
        if (contr_rt[1] !== "diffs_shunt") {
          console.log("Clear diffs Shunt");
          clearInterval(diffs_shunt_interval);
        }
      }, 5000);
    },
    methods: {
      haveMagnets(master_id) {
        axios.post(constants.ROOT_URL + '/api/v1/real_time_value_master', {
          system_id: this.system.id,
          client_device: 'd',
          vars: '[["' + master_id + '", "R$EVE_E_MagnetoDif_Pou_ON.ST", "R$EVE_E_MagnetoDif_Bassa_ON.ST"]]'
        }).then((response) => {
          if(response.data[0].value=1){
            this.mag_dif_well = "ON";
          }else if(response.data[0].value=0){
            this.mag_dif_well = "OFF";
          }else{
            this.mag_dif_well = "S/D";
          }

          if(response.data[1].value=1){
            this.mag_dif_raft = "ON";
          }else if(response.data[1].value=0){
            this.mag_dif_raft = "OFF";
          }else{
            this.mag_dif_raft = "S/D";
          }
        }, (response) => {
          console.log(response);
        });
      },
      // Llegir un event determinat
      getEventsGenerator(control_par, eve_par) {
        var control = control_par;
        axios.post(constants.ROOT_URL + '/api/v1/event', {
          system_id: this.system.id,
          event: eve_par,
          client_device: 'd',
          date_range: dateRanges.currentMonthDaterange()
        }).then((response) => {
          function reverseEve(st) {
            if (st === "ON") {
              return "OFF"
            } else {
              return "ON"
            }
          }

          var response_return = [];
          if (response.data.hasOwnProperty("record")) {
            for (var i = 0; i < response.data.record.length; i++) {
              response_return.push({
                date: moment(response.data.record[i].date, "DDMMYYYYhhmmss").add(1, 'h').format('DD/MM/YYYY HH:mm:ss'),
                shunter: "Grup",
                value: reverseEve(response.data.record[i].value)
              });
            }
          }

          if(control==="well"){
            this.list_events_well = response_return;
          }else if(control==="raft"){
            this.list_events_raft = response_return;
          }
        }, (response) => {
          console.log(response.data)
        })
      },
      changeStatusMagDif(element_par, new_value_par){
        var element = element_par;
        var new_value = new_value_par;
        swal({
          title: 'Maniobra Mag/Diff!',
          text: "Està segur que vol posar el mag/diff a "+new_value+"?",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'SI',
          cancelButtonText: 'NO'
        }).then((result) => {
          if (result.value) {
            if(element==='raft'){
              this.forceVariableFunction("LM4A-NivellBassa", "DO2", 1);
            }else{
              this.forceVariableFunction("EDS-Roijals", "DO5", 1);
            }
          }
        })
      },
      // Cambiar variable a un dispositiu
      forceVariableFunction(device, var_to_change, new_value) {
        axios.post(constants.ROOT_URL + '/api/v1/shunting_action', {
          system_id: this.system.id,
          device: device,
          var_to_change: var_to_change,
          client_device: 'd',
          new_value: new_value
        }).then((response) => {
          console.log(response.data);
          swal(
            'Completat!',
            'Acció completada correctament.',
            'success'
          )
        }, (response) => {
          console.log(response.data);
          swal(
            'ERROR',
            'Acció no completada',
            'error'
          )
        });
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// DiffShunting.vue?06a5d9ed